import { init, setupVueErrorHandler } from 'yl-nsm-track'

/**
 * 初始化埋点 SDK
 * - 从环境变量读取应用 ID
 * - 配置上报域名和 SDK 参数
 */
export function trackInit() {
  const appId = Number(process.env.VUE_APP_TRACK_APP_ID)
  init(appId, {
    channelDomain: 'https://snssdk.jtjms-mx.com',
    sdkScriptUrl: 'https://datafinder.jtjms-mx.com/minio.byterangers.onpremise.docor.static/collect-privity-v5.2.11.js',
    globalProperties: {},
    reportPageStay: true,
  })
}

/**
 * 接入 Vue 错误处理桥接
 * - Vue 2：传入 Vue 构造函数
 * - Vue 3：传入 createApp() 返回的 app 实例
 * @param {object} Vue - Vue 2 构造函数或 Vue 3 app 实例
 */
export function vueErrorHandler(Vue) {
  setupVueErrorHandler(Vue)
}

/**
 * 上报页面浏览（PV）
 * @param {Object} to   - 目标路由对象（vue-router）
 * @param {Object} from - 来源路由对象（vue-router）
 */
export function trackPv(to, from) {
  window.$track &&
    window.$track.$pv({
      referrer: from.fullPath,
      page_title: (to.meta && to.meta.title) || to.name || '',
      page_url: to.fullPath,
      page_query: JSON.stringify(to.query),
    })
}
